<template>
	<div  >
    <!-- {{this.$route.query.blockId}}   -->
	 <complaint-list  ></complaint-list> 

	</div>
</template>

<script>
	// @ is an alias to /src

	import ComplaintList from '@/components/project/mainlist/ComplaintList.vue'
	export default {
		name: 'complaint',
		components: {
			ComplaintList
		},
		data(){
			 
			return {
				 
			}
			
		},
		created() {
 	         //this.$Message.success('home!');
		}


	}
</script>

